var app = angular.module('leonardo');

var LevelStateName = function (LevelService) {
  return function (property) {
    var label = '-';
    angular.forEach(property.levels, function(value) {
      if (value.level_type == LevelService.TYPE_STATE) {
        label = value.name;
      }
    });
    return label;
  }
};

app.filter('levelStateName', ['LevelService', LevelStateName]);

var LevelCountyName = function (LevelService) {
  return function (property) {
    var label = '-';
    angular.forEach(property.levels, function(value) {
      if (value.level_type == LevelService.TYPE_COUNTY) {
        label = value.name;
      }
    });
    return label;
  }
};

app.filter('levelCountyName', ['LevelService', LevelCountyName]);


var LevelCityName = function (LevelService) {
  return function (property) {
    var label = '-  ';
    angular.forEach(property.levels, function(value) {
      if (value.level_type == LevelService.TYPE_CITY) {
        label = value.name;
      }
    });
    return label;
  }
};

app.filter('levelCityName', ['LevelService', LevelCityName]);